/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type ListModelConfigsPathParams = NonNullable<operations['listModelConfigs']['parameters']['path']>;

export type ListModelConfigsQueryParams = NonNullable<operations['listModelConfigs']['parameters']['query']>;

export interface Input extends ListModelConfigsPathParams {
  apiVersion?: string;
  query?: ListModelConfigsQueryParams;
}

export async function listModelConfigs(
  { apiVersion, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/api/v2/projects/{projectKey}/ai-configs/model-configs', {
    params: { path, query },
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
